import { SALES_ORDER_CREATE_PAGE } from "routes/route.constant";
import CreateSalesOrder from "./CreateSalesOrder";

const route = {
  path: SALES_ORDER_CREATE_PAGE,
  element: CreateSalesOrder,
};

export default route;
